export default __webpack_public_path__ + "static/media/pot1.50029e03.svg";